// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"133":"891291ee","698":"26cb73e3"}[chunkId] + ".js";
};